import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import urls from '../network/urls';
import PdfViewer from './PdfViewer';

// The report opens in a popup dialog (portal to body, above the appointment
// modal) rather than expanding inline. The PDF is rendered by PdfViewer
// (canvas) so it always displays regardless of the browser's
// "Download PDFs" setting. The Download button hits the same endpoint with
// &download=1 so the server sends it as an attachment with a proper filename:
// "<client>-<service number>-<DD-MM-YYYY>.pdf".
export default ({ header, auth, templateId, appointmentId, companyId }) => {

  const [show, setShow] = useState(false);

  const base = urls.getBase() + `/customer/${companyId}/${appointmentId}/${templateId}/document`;
  const nameParam = `name=${encodeURIComponent(header || 'Document')}`;
  const previewUrl = `${base}?${nameParam}`;
  const downloadUrl = `${base}?${nameParam}&download=1`;

  // Close on Escape while open.
  useEffect(() => {
    if (!show) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setShow(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [show]);

  return (
    <div style={{ margin: '6px 0' }}>
      <button type='button' onClick={() => setShow(true)} style={{
        display: 'inline-flex', alignItems: 'center', gap: 8, padding: '8px 15px',
        borderRadius: 10, cursor: 'pointer', fontSize: 13, fontWeight: 700,
        fontFamily: 'var(--font-display, inherit)',
        background: 'rgba(13,161,178,0.10)', color: 'var(--primary-dark, #067886)',
        border: '1px solid rgba(13,161,178,0.30)',
      }}>
        <i className="fas fa-file-invoice"></i> View {header}
      </button>

      {show && templateId && ReactDOM.createPortal(
        <div
          onClick={(e) => { if (e.target === e.currentTarget) setShow(false); }}
          style={{
            position: 'fixed', inset: 0, zIndex: 1400,
            background: 'rgba(15,31,46,0.55)',
            WebkitBackdropFilter: 'blur(4px)', backdropFilter: 'blur(4px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 16px',
          }}
        >
          <div role="dialog" aria-modal="true" style={{
            width: '100%', maxWidth: 1000, height: '90vh',
            display: 'flex', flexDirection: 'column',
            background: '#fff', borderRadius: 16, overflow: 'hidden',
            boxShadow: '0 24px 60px rgba(15,31,46,0.35)',
          }}>
            <div style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12,
              padding: '13px 18px', borderBottom: '1px solid rgba(15,31,46,0.08)',
              background: 'rgba(255,255,255,0.7)',
              WebkitBackdropFilter: 'blur(20px) saturate(1.4)', backdropFilter: 'blur(20px) saturate(1.4)',
            }}>
              <span style={{ fontFamily: 'var(--font-display, inherit)', fontWeight: 800, fontSize: 16, color: 'var(--text, #0f1f2e)' }}>
                <i className="fas fa-file-invoice" style={{ color: 'var(--primary, #0DA1B2)', marginRight: 8 }}></i>{header}
              </span>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <a href={downloadUrl} download className="btn btn-primary btn-sm" style={{ textDecoration: 'none', color: 'white' }}>
                  <i className="fas fa-download" style={{ marginRight: 6 }}></i>Download
                </a>
                <button type="button" onClick={() => setShow(false)} aria-label="Close" style={{
                  background: 'rgba(15,31,46,0.06)', border: 'none', color: 'var(--text-secondary)',
                  width: 34, height: 34, borderRadius: 9, cursor: 'pointer', fontSize: 18, lineHeight: 1,
                }}>×</button>
              </div>
            </div>
            <div style={{ flex: 1, minHeight: 0 }}>
              <PdfViewer url={previewUrl} height="100%" />
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
}
